import { INotification, ISiteContact, IUser, IUserAdmin, IUserStatusCounts } from "utils/types";

export type IUserBluePrint = (keyof IUser)[];
export type INotificationBluePrint = (keyof INotification)[];
export type IUserAdminBluePrint = (keyof IUserAdmin)[]
export type IUserStatusCountsBluePrint = (keyof IUserStatusCounts)[]
export type IContactMessageBluePrint = (keyof ISiteContact)[]



export const contactMessageQuery: IContactMessageBluePrint = [
    "email",
    "fullName",
    "id",
    "message",
    "phoneNumber",
    "reason",
]
export const userStatusCountsQuery:IUserStatusCountsBluePrint = [
    "active",
    "suspended",
    "total"
]
export const userAdminQuery:IUserAdminBluePrint = [
    "adminRole",
    "createdAt",
    "id",
    "userId"
]
export const userQuery:IUserBluePrint = [
    "avatar", "country", "email", "firstName", "gender",
    "id", "lastName", "lastName", "lastOnline", "onActivePremium",
    "profession", "purpose", "studentLevel", "testType", "userStatus",
    "userAdmin", "createdAt"
]
export const notificationQuery: INotificationBluePrint = [
    
]



export interface ICreateContactMessageRequest {
    contactMessage: Partial<ISiteContact>
}
export interface ICreateContactMessageResponse {
    success: boolean;
}
export const createContactMessageResponse: (keyof ICreateContactMessageResponse)[] = ["success"]


export interface IGetUserStatusStatsResponse {
    userStatusCounts: IUserStatusCounts
}
export const getUserStatusStatsResponse: (keyof IGetUserStatusStatsResponse)[] = [
    "userStatusCounts"
]
export interface IGetUserStatusStatsResponseNestedBluePrint {
    userStatusCounts: IUserStatusCountsBluePrint
}
export const getUserStatusStatsResponseNestedBluePrint:IGetUserStatusStatsResponseNestedBluePrint = {
    userStatusCounts: userStatusCountsQuery
}

export type IGetAdminUserStatusStatsResponse = IGetUserStatusStatsResponse;
export const getAdminUserStatusStatsResponse: (keyof IGetAdminUserStatusStatsResponse)[] = getUserStatusStatsResponse
export type IGetAdminUserStatusStatsResponseNestedBluePrint = IGetUserStatusStatsResponseNestedBluePrint
export const getAdminUserStatusStatsResponseNestedBluePrint:IGetAdminUserStatusStatsResponseNestedBluePrint = getUserStatusStatsResponseNestedBluePrint

export interface IUpdateNotificationRequest {
    notificationId: string,
    notification: Partial<INotification>
}
export interface IUpdateNotificationResponse {
    notification: INotification;
}

export interface IGetNotificationCountRequest {
    userId: string;
}
export interface IGetNotificationCountResponse {
    count: number;
}
export interface IGetNotificationsRequest {
    notificationIds?: string;
    notification?: INotification;
    limit: number;
    skip: number;
}
export interface IGetNotificationsResponse {
    notifications: INotification[];
}
export interface IGetNotificationsResponseBluePrint extends Omit<IGetNotificationResponseBluePrint, "notification"> {
    notifications: INotificationBluePrint;
}
export interface IGetNotificationRequest {
    notification: Partial<INotification>;
}
export interface IGetNotificationResponse {
    notification: INotification
}
export interface IGetNotificationResponseBluePrint {
    notification: INotificationBluePrint;
}
export interface IUpdateCredentialRequest {
    userId: string;
    password: string;
    email?: string;
    phone?: string;
}
export interface IUpdateCredentialResponse {
    success: boolean;
}
export interface IDeleteUserRequest {
    userId: string;
}
export interface IDeleteUserResponse {
    userId: string;
}
export const deleteUserResponse: (keyof IDeleteUserResponse)[] = ["userId"];

export interface IUpdateUserRequest {
    userId: string;
    user: Partial<IUser>;
}
export interface IUpdateUserResponse {
    user: IUser
}
export type IUpdateUserResponseBluePrint = IGetUserResponseBluePrint;
export interface IGetUsersRequest {
    search?: string;
    limit: number;
    skip: number;
    userIds?: string[];
    user?: Partial<IUser>;
}
export interface IGetUsersResponse {
    users: IUser[];
    total: number;
}
export interface IGetUsersResponseBluePrint extends Omit<IGetUserResponseBluePrint, "user"> {
    users: IUserBluePrint;
}
export interface IGetUserRequest {
    user: Partial<IUser>;
}
export interface IGetUserResponse {
    user: IUser
}
export interface IGetUserResponseBluePrint {
    user: IUserBluePrint;
    userAdmin: IUserAdminBluePrint;
}
export interface IMeRequest {}
export interface IMeResponse {
    user: IUser
}
export interface IMeResponseBluePrint extends IGetUserResponseBluePrint {

}